<script lang="ts">
    import { spaNavigate } from "../actions"
    import { sidebarOverlay } from "../store"
</script>

<header>
    <div class="header-wrapper">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
        <img
            on:click="{() => {
                spaNavigate('/')
            }}"
            src="../../../assets/img/Logo.png"
            alt="logo"
        />
        <button
            on:click="{() => {
                sidebarOverlay.set(true)
            }}"
            ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
            >
                <path
                    d="M4 8H28V10.6667H4V8ZM4 14.6667H28V17.3333H4V14.6667ZM4 21.3333H28V24H4V21.3333Z"
                    fill="#26292C"></path>
            </svg>
        </button>
    </div>
</header>

<style lang="less">
    header {
        border-radius: 0px 0px 1.2rem 1.2rem;
        border-top: 4px solid var(--yellow-100);
        background: var(--yellow-100);
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 1.2rem;
        .header-wrapper {
            max-width: var(--normal-max-width);
            width: 100%;
            display: flex;
            justify-content: space-between;
            position: sticky;
            top: 0px;

            align-items: center;
            gap: 1.2rem;
            z-index: 9999;
            img {
                cursor: pointer;
            }
        }
    }
</style>
